import { RECEIVE_DIVIDENDS_AND_INTEREST_SUMMARY, REQUEST_DIVIDENDS_AND_INTEREST_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_DIVIDENDS_AND_INTEREST_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_DIVIDENDS_AND_INTEREST_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
